(function() {
  'use strict';

  function ModalServicoSuspensoCtrl($scope, $rootScope, $uibModalInstance, $state, $http, URL_SERVICO_FISCAL, redirectToEncomendas, nomeOperacao) {

    $scope.nomeOperacao = nomeOperacao;
    $scope.podeEnviarComprovante = false;

    // Liberação temporária por comprovante (XD-2207): o botão só aparece para o seller elegível.
    // Esconder aqui é só UX; o billing-services reavalia a regra no envio. Se a consulta falhar,
    // o modal fica como antes, apenas informativo.
    $http.get(URL_SERVICO_FISCAL + '/v2/liberacao-temporaria/elegibilidade')
      .then(function(response) {
        $scope.podeEnviarComprovante = !!(response.data && response.data.eligible);
      });

    $scope.cancelar = function() {
      $uibModalInstance.dismiss('cancel');

      if(redirectToEncomendas) {
        $state.go('encomendas');
      }
    }

    // O envio acontece na tela de faturas, que abre o modal de comprovante ao receber o parâmetro.
    $scope.jaPaguei = function() {
      $uibModalInstance.dismiss('ja-paguei');
      $state.go('faturas', { comprovante: true });
    }

  };

  angular
    .module('mandaeApp')
    .controller('ModalServicoSuspensoCtrl', ModalServicoSuspensoCtrl);


})();
